import { styled } from '../design-tokens';

export const RedPath = styled('path', { fill: '$pink' });
export const BluePath = styled('path', { fill: '$blue' });
export const GreenPath = styled('path', { fill: '$green' });
export const CyanPath = styled('path', { fill: '$cyan' });
